import { lang } from "../../i18nLang";

export class ContractSharedException extends Error {
  protected _code: string;

  constructor() {
    super(lang("contract.errors.deleteShared"));

    this.name = "ContractSharedException";
    this._code = "contractShared";
  }
}

export class ContractHasMeasurementException extends Error {
  protected _code: string;

  constructor() {
    super(lang("contract.errors.deleteWithMeasurement"));

    this.name = "ContractHasMeasurementException";
    this._code = "contractHasMeasurement";
  }
}
